import { AxiosResponse } from 'axios';
import { nameCodeStateCommunication } from 'civil-status/constants/code-state-communications';
import { getNameTypeEvent } from 'civil-status/utils/get-name-type-event';
import { ArchivioAnnotazioni } from 'civil-status/view-models/archive-annotations-list';
import { CommunicationList } from 'civil-status/view-models/communication-from-list';
import { DateTime } from 'luxon';
import { HttpResponse, PaginationInformation } from 'shell/models/http-response';

export const transformCommunicationList = (
  response: AxiosResponse<HttpResponse<Array<ArchivioAnnotazioni>>>
): Array<CommunicationList> => {
  const dataRes = response.data.payload || [];
  const datiPaginazione = (response.data.pageInfo || {}) as PaginationInformation;

  return dataRes.map(
    (item) =>
      ({
        totalCount: datiPaginazione?.totalCount || 0,
        typeEvent: getNameTypeEvent(item.tipoAttoSecondario),
        code: `${item.codComunicazione || ''} ${item.testoIntestazione || ''}`,
        idAnsc: item.idAnscAttoSecondario || '',
        holder: item.testoNote || '',
        dateAct: item.timestampInserimento
          ? DateTime.fromISO(item.timestampInserimento).toFormat('dd/MM/yyyy')
          : '',
        datePrint: item.dataRegistrazioneAnnotazione
          ? DateTime.fromISO(item.dataRegistrazioneAnnotazione).toFormat('dd/MM/yyyy')
          : '',
        statePrint: nameCodeStateCommunication(item.codStatoComunicazione || ''),
        datiComunicazione: item,
      } as CommunicationList)
  );
};
